import { render, staticRenderFns } from "./VPic.vue?vue&type=template&id=edffa9e2&scoped=true&"
import script from "./VPic.vue?vue&type=script&lang=js&"
export * from "./VPic.vue?vue&type=script&lang=js&"
import style0 from "./VPic.vue?vue&type=style&index=0&id=edffa9e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edffa9e2",
  null
  
)

export default component.exports